var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6C5.55228 6 6 6.44772 6 7C6 7.55228 5.55228 8 5 8ZM5 10C3.34315 10 2 8.65685 2 7C2 5.34315 3.34315 4 5 4C6.65685 4 8 5.34315 8 7C8 7.80866 7.68005 8.54258 7.15983 9.0821L8.62983 12.0221C7.93068 12.1082 7.30599 12.4349 6.84112 12.9168L5.37134 9.97724C5.24967 9.99226 5.12574 10 5 10ZM15 10C14.4477 10 14 9.55228 14 9C14 8.44772 14.4477 8 15 8C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10ZM12.2923 10.2933C12.1049 9.90172 12 9.46312 12 9C12 7.34315 13.3431 6 15 6C16.6569 6 18 7.34315 18 9C18 9.80866 17.68 10.5426 17.1598 11.0821L18.6298 14.0221C17.9307 14.1082 17.306 14.4349 16.8411 14.9168L15.3713 11.9772C15.2497 11.9923 15.1257 12 15 12C14.5368 12 14.0982 11.895 13.7065 11.7076L11.7081 13.706C11.4125 13.0882 10.9116 12.5874 10.2939 12.2918L12.2923 10.2933ZM19 18C18.4477 18 18 17.5523 18 17C18 16.4477 18.4477 16 19 16C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18ZM19 20C17.3431 20 16 18.6569 16 17C16 15.3431 17.3431 14 19 14C20.6569 14 22 15.3431 22 17C22 18.6569 20.6569 20 19 20ZM8 15C8 15.5523 8.44772 16 9 16C9.55228 16 10 15.5523 10 15C10 14.4477 9.55228 14 9 14C8.44772 14 8 14.4477 8 15ZM6 15C6 16.6569 7.34315 18 9 18C10.6569 18 12 16.6569 12 15C12 13.3431 10.6569 12 9 12C7.34315 12 6 13.3431 6 15Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.0bd4953bddb99a09db5f6061444e0c48.svg";
export { ForwardRef as ReactComponent };